import Wechat from "../../utils/wechat"
import * as types from "../mutation-types"
import cookies from "../../utils/cookies"
import * as ua from "../../utils/ua"
import Raven from "raven-js"
import * as url from "../../utils/url"
import * as report from "../../utils/report"
import * as request from "../../utils/request"
import * as userApi from "../../api/user"
import * as Sentry from "@sentry/browser"
const state = {
  sandbox: url.getParam("sandbox"),
  pf: url.getParam("pf"),
  openid: "",
  openkey: "",
  sessionId: "",
  sessionType: "",
  wxAppid2: "",
  qqAppid: "",
  accountType: "",
  userAgent: ua.getUserAgent(),
  nickname: "",
  avatar: ""
}

const getters = {
  sandbox: state => state.sandbox,
  pf: state => {
    // 为了防止游戏内拼接链接导致pf获取错误，这里针对游戏内场景写死pf
    return state.userAgent.msdk ? "__mds_client_activity_login" : state.pf || "__mds_default"
  },
  loginState: state => {
    let session = {
      openid: state.openid,
      openkey: state.openkey,
      session_id: state.sessionId,
      session_type: state.sessionType
    }
    if (state.wxAppid2) {
      session.wx_appid = state.wxAppid2
    } else if (state.qqAppid) {
      session.qq_appid = state.qqAppid
    }
    return session
  },
  accountType: state => state.accountType,
  userAgent: state => state.userAgent,
  avatar: state => state.avatar,
  nickname: state => state.nickname
}

const actions = {
  getLoginState({ state, commit, dispatch }) {
    return new Promise((resolve, reject) => {
      if (!state.openid || !state.openkey) {
        if (state.userAgent.weixin) {
          let wechat = new Wechat({
            getDetail: 1
          })
          if (wechat.init()) {
            wechat.getOpenid({
              onSuccess: function() {
                commit(types.SET_USER_LOGIN_STATE, {
                  openid: this.openid,
                  openkey: this.accessToken,
                  sessionId: "hy_gameid",
                  sessionType: "wc_actoken",
                  wxAppid2: "wx951bdcac522929b6",
                  accountType: "wechat"
                })
                if (this.info.headimgurl) {
                  commit(types.SET_USER_AVATAR, this.info.headimgurl.replace(/https?/gi, "https"))
                }
                if (this.info.nickname) {
                  commit(types.SET_USER_NICKNAME, this.info.nickname)
                }
                resolve({
                  openid: this.openid,
                  openkey: this.accessToken,
                  userInfo: this.info
                })
              },
              onError: () => {
                reject()
              }
            })
          }
        } else if (state.userAgent.QQ) {
          let loginState = {
            openid: cookies.get("uin").substr(1) * 1,
            openkey: cookies.get("skey"),
            sessionId: "uin",
            sessionType: "skey",
            accountType: "qq"
          }
          commit(types.SET_USER_LOGIN_STATE, loginState)
          commit(types.SET_USER_AVATAR, `//q.qlogo.cn/g?b=qq&nk=${loginState.openid}&s=100`)

          resolve(loginState)
        } else if (window._msdkLoginParams && state.userAgent.msdk) {
          if (_msdkLoginParams.acctype === "wx" || _msdkLoginParams.acctype === "weixin") {
            let loginState = {
              openid: _msdkLoginParams.openid,
              openkey: _msdkLoginParams.access_token,
              sessionId: "hy_gameid",
              sessionType: "wc_actoken",
              wxAppid2: _msdkLoginParams.appid,
              accountType: "wechat"
            }
            commit(types.SET_USER_LOGIN_STATE, loginState)
            dispatch("getWechatNicknameAndAvatar")
            resolve(loginState)
          } else if (_msdkLoginParams.acctype === "qq") {
            /**
             *  {
    "acctype": "qq",
    "appid": "1104922185",
    "openid": "4C5782CCFEF74AE493A71B526C43DDC1",
    "access_token": "E51744B676BDABA33EF0E9160609E279",
    "pay_token": "45DD6BF183D747520BCF974977835EFF",
    "platid": "0"
   }
             */
            let loginState = {
              openid: _msdkLoginParams.openid,
              openkey: _msdkLoginParams.access_token,
              sessionId: "openid",
              sessionType: "kp_accesstoken",
              qqAppid: _msdkLoginParams.appid,
              accountType: "qq"
            }
            commit(types.SET_USER_LOGIN_STATE, loginState)
            resolve(loginState)
          } else {
            reject("无登陆态")
          }
        } else {
          // dispatch("reportUserAction", {
          //   iformat: config.REPORT.PAGEVIEW.OUTGAME_BARGAIN_NON_WECHAT_AND_QQ
          // })
          reject("无登陆态")
        }
      } else {
        resolve({
          openid: state.openid,
          openkey: state.openkey,
          sessionId: state.sessionId,
          sessionType: state.sessionType,
          wxAppid2: state.wxAppid2
        })
      }
    })
      .then(loginState => {
        Sentry.configureScope(scope => {
          scope.setUser({ id: loginState.openid, ...loginState })
        })
        return loginState
      })
      .catch(res => {
        Raven.captureException(new Error("get-login-state-error"), {
          tags: { type: "get-login-state-error" },
          extra: {
            res,
            state
          }
        })

        throw res
      })
  },
  getWechatNicknameAndAvatar({ getters, commit }) {
    request
      .ajax({
        url: "//pay.qq.com/cgi-bin/account/get_wechat_userinfo.cgi",
        data: {
          get_detail: 2,
          openid: getters.loginState.openid,
          access_token: encodeURIComponent(getters.loginState.openkey)
        }
      })
      .then(res => {
        if (res.resultcode == 0) {
          commit(types.SET_USER_AVATAR, res.resultinfo.obj.headimgurl.replace(/https?/gi, "https"))
          commit(types.SET_USER_NICKNAME, res.resultinfo.obj.nickname)
        }
      })
  },

  reportUserAction({ getters }, params) {
    let data = {
      3: getters.loginState.openid,
      8: JSON.stringify(params.resultInfo || ""),
      // 19: getters.currentItem && getters.currentItem.code,
      13: 1,
      21: params.iformat,
      26: `vip_m-${getters.pf || "pay_html5"}_-html5`,
      24: url.getParam("offerId") || getters.offerId,
      37: getters.loginState.session_id,
      43: getters.loginState.session_type,
      41: getters.loginState.wx_appid,
      50: navigator.userAgent,
      // 51: getters.aid,
      36: location.href
    }

    setTimeout(() => {
      report.dataReport(data)
    }, 0)
  },

  /**
   * 上报日志并跳转
   * @param {*} params.iformat
   * @param {*} params.target Target页面
   * @param {*} param.pfStructure
   * @param {*} params.resultInfo
   */
  reportAndJump({ getters }, params) {
    let data = {
      3: getters.loginState.openid,
      8: JSON.stringify(params.resultInfo || ""),
      // 19: getters.currentItem && getters.currentItem.code,
      13: 1,
      21: params.iformat,
      26: `vip_m-${getters.pf || "pay_html5"}_-html5`,
      24: url.getParam("offerId") || getters.offerId,
      37: getters.loginState.session_id,
      43: getters.loginState.session_type,
      41: getters.loginState.wx_appid,
      50: navigator.userAgent,
      // 51: getters.aid,
      36: location.href
    }
    let opts = {
      target: params.target,
      webversion: "h5store_activity_v1.0"
    }

    setTimeout(() => {
      report.jumpReport(data, opts)
    }, 0)
  },

  /**
   * 地址生成二维码图片
   * @param getters
   * @param url
   * @param success
   */
  generateQRCode({ getters }, { url, success }) {
    return userApi.generateQRCode({ url, success, off: getters.offerId })
  },
  /**
   * dom生成二维码图片
   * @param getters
   * @param id dom的id
   */
  generateScreenShot({ getters }, id) {
    return userApi.generateScreenShots(id, getters.offerid)
  },
  getMqqUrlImage({ getters }, { url, callback }) {
    if (getters.userAgent.QQ) {
      return userApi.getUrlImage(
        {
          callid: "mqqavatar",
          url: `${location.protocol}${url}`
        },
        callback
      )
    }
  }
}
const mutations = {
  [types.SET_USER_LOGIN_STATE](state, { openid, openkey, sessionId, sessionType, wxAppid2, qqAppid, accountType }) {
    state.openid = openid
    state.openkey = openkey
    state.sessionId = sessionId
    state.sessionType = sessionType
    state.accountType = accountType
    wxAppid2 && (state.wxAppid2 = wxAppid2)
    qqAppid && (state.qqAppid = qqAppid)
  },
  [types.SET_USER_AVATAR](state, avatar) {
    state.avatar = avatar
  },
  [types.SET_USER_NICKNAME](state, nickname) {
    state.nickname = nickname
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
